import { NudgingSubscriptionBanner } from '@/pages/ui/nudging-subscribe-banner/nudging-subscribe-banner'

import { cn } from '@/lib/utils'

export interface SubscriptionOverlayProps {
  isAdmin?: boolean
  isFreeTrialAvailable?: boolean
}

export const SubscriptionOverlay = ({ isAdmin, isFreeTrialAvailable }: SubscriptionOverlayProps) => {
  return (
    <div
      className={cn(
        'absolute inset-0 left-0 top-0',
        'flex flex-col justify-end',
        'border-[3px] border-slate-500',
        'bg-[rgba(30,41,59,0.40)]',
        'rounded-[10px]',
        'backdrop-blur-[2.5px]',
        'p-6'
      )}
    >
      <NudgingSubscriptionBanner
        contentFlow="horizontal"
        isAdmin={isAdmin}
        isFreeTrialAvailable={isFreeTrialAvailable}
      />
    </div>
  )
}
